var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63216 9.05841C7.54883 9.05008 7.44883 9.05008 7.35716 9.05841C5.37383 8.99175 3.79883 7.36675 3.79883 5.36675C3.79883 3.32508 5.44883 1.66675 7.49883 1.66675C9.54049 1.66675 11.1988 3.32508 11.1988 5.36675C11.1905 7.36675 9.61549 8.99175 7.63216 9.05841Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6747 3.33325C15.2914 3.33325 16.5914 4.64159 16.5914 6.24992C16.5914 7.82492 15.3414 9.10825 13.7831 9.16659C13.7164 9.15825 13.6414 9.15825 13.5664 9.16659",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46563 12.1333C1.44896 13.4833 1.44896 15.6833 3.46563 17.0249C5.75729 18.5583 9.51563 18.5583 11.8073 17.0249C13.824 15.6749 13.824 13.4749 11.8073 12.1333C9.52396 10.6083 5.76562 10.6083 3.46563 12.1333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2832 16.6667C15.8832 16.5417 16.4499 16.3001 16.9165 15.9417C18.2165 14.9667 18.2165 13.3584 16.9165 12.3834C16.4582 12.0334 15.8999 11.8001 15.3082 11.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoUserManagement);
export default __webpack_public_path__ + "static/media/trvto_userManagement.11395242ff517bee1c98e0eed7ae49d6.svg";
export { ForwardRef as ReactComponent };